import { API } from '@thuas/pd-schemas';
import api from 'helpers/api';
import { callGet, Retrieving } from 'helpers/apiTypes';
import { prepareForBackend } from 'helpers/objects';

export type IPublication = API['Publication']['read'];
export type IPublicationCreate = API['Publication']['create'];
export type IPublicationUpdate = API['Publication']['update'];

function prepareForUpdate(publication: IPublication): IPublicationUpdate {
  const updated = prepareForBackend(publication, ['id']) as IPublicationUpdate;
  return updated;
}

function prepareForCreate(publication: IPublication): IPublicationCreate {
  return prepareForBackend(
    {
      ...publication,
    },
    ['id'],
  ) as IPublicationCreate;
}

export const fetchPublications = async () => {
  try {
    const query = {
      '*': true,
      image: {
        '*': true,
      },
      author: {
        id: true,
        username: true,
      },
    } as const satisfies Retrieving<'Publication'>;
    const response = await callGet('Publication', query);
    return response.response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const postPublicationData = async (data: IPublication) => {
  try {
    const response: any = await api.post('Publication', prepareForCreate(data));
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const patchPublicationData = async (data: IPublication) => {
  try {
    const response = await api.patch(
      'Publication/' + data.id,
      prepareForUpdate(data),
    );
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const deletePublicationData = async (id: number) => {
  try {
    const response: any = await api.delete('Publication/' + id);
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};